import type { SitePreviewExtended } from '@/api/fe-api/domain/entities/site';

export enum PotentialGain {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export type RevenueOpportunity = {
  fullFrontendId: string;
  revenueOpportunity: number;
  potentialGain: PotentialGain;
};

export type SiteListItemProps = {
  site: SitePreviewExtended;
};
